import { tns } from 'tiny-slider/src/tiny-slider';
const $sliders = document.querySelectorAll('.act-actualite-slider-group ul');
const readMores = document.querySelectorAll('.act-actualite-slider-group .wp-block-read-more');
let $is_desktop = true;
if (screen.width < 1024) {
    $is_desktop = false;
}
var mql_test = window.matchMedia('(min-width: 1024px)');

mql_test.onchange = (e) => {
    if (e.matches) {
        $is_desktop = true;
    }
    else {
        $is_desktop = false;
    }
}
(function ($) {
    var slider = null;
    $(document).ready(function () {
        if($is_desktop) {
            $sliders.forEach(function ($slider) {
                var $parent = $slider.closest('.tns-outer')
                var $id = $slider.getAttribute('id');
                slider = tns({
                    container: '#' + $id,
                    mode:'gallery',
                    // autoWidth: true,
                    loop: false,
                    items: 1,
                    center: false,
                    mouseDrag: true,
                    slideBy: 1,
                    swipeAngle: false,
                    speed: 400,
                    autoplay: false,
                    gutter:0,
                    controlsText: ['<svg class="icon icon-previous"><use xlink:href="#icon-previous"></use></svg>', '<svg class="icon icon-next"><use xlink:href="#icon-next"></use></svg>'],
                    controlsPosition: "bottom",
                    navPosition: "bottom",
                    onInit: function (info) {
                        info.controlsContainer.setAttribute('tabindex', -1);
                        info.nextButton.setAttribute('tabindex', 0);
                        info.prevButton.setAttribute('tabindex', 0);
                    },
                });
            });
        }
    });
    if(readMores){
        readMores.forEach(function (el) {
            el.addEventListener('focus',function(e){
                //console.log('b');
                e.preventDefault();
                var slidenb = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('data-slidenb');
                slider.goTo(slidenb);
                return false;
            })
        })
    }
})(jQuery);
